export default function auditLogPanelId(rowId) {
  return `auditLogDebugPanel-${rowId}`;
}
